import React, { useContext } from 'react';
import * as language from '../constants/languages';
import DrawerIcon from '../assets/svg/header/drawericon.svg';
import ShoppingCart from '../assets/svg/shopping_cart.svg';
import CompanyLogo from '../assets/header_logo.png';
import Badge from '@mui/material/Badge';
import { AuthContext } from '../pages/RootPage';
import { useNavigate } from 'react-router-dom';
import '../styles/SearchHeader.css'

class SearchHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchedProductName: this.props.value,
            whatsAppNo: "",
            badgeCount: 0,
            logo: CompanyLogo
        };

        this.getCartCount = this.getCartCount.bind(this);
    }

    componentDidMount() {
        this.getCompanyInfo();
        this.getCartCount();
        window.addEventListener('productQtyChange', this.getCartCount);
    }

    componentWillUnmount() {
        window.removeEventListener('productQtyChange', this.getCartCount);
    }

    getCartCount() {
        const cart = localStorage.getItem('cartItems');
        if (!cart) {
            this.setState({ badgeCount: 0 });
        } else {
            const cartItems = JSON.parse(cart);
            this.setState({ badgeCount: cartItems?.customerCartItems?.length || 0 });
        }
    }

    //get store name
    async getCompanyInfo() {
        const value = localStorage.getItem('companyInfo')
        if (value) {
            this.companyInfo = JSON.parse(value);
            const Logo = (this.companyInfo.logo && this.companyInfo.logo !== "") ? this.companyInfo.logo : CompanyLogo;
            this.setState({
                logo: Logo,
                whatsAppNo: this.companyInfo.whatsAppNo || ""
            })
        }
    }

    async openWhatsapp() {
        window.open('whatsapp://send?phone=' + this.state.whatsAppNo)
    }

    // search product
    async searchProduct() {
        this.props.searchName(this.state.searchedProductName)
    }

    keydown(e) {
        if (e.key === "Enter") {
            this.searchProduct()
        }
    }

    render() {
        return (
            <div style={{ position: 'sticky', top: 0, zIndex: 999, backgroundColor: '#ffffff', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', display: 'flex', flexDirection: 'column', paddingBlock: '0.6rem', paddingInline: '12px', margin: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                    <div style={{ justifyContent: 'center', cursor: 'pointer', display: 'flex', alignItems: 'center' }} onClick={() => this.props.toggleDrawer()}>
                        <img src={DrawerIcon} style={{ width: 20, height: 20 }} alt="Menu" />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            paddingInline: "8px",
                        }}
                        onClick={() => this.props.navigate && this.props.navigate("/")}
                    >
                        <img src={this.state.logo || CompanyLogo} height="auto" width={140} alt="Store Logo" style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "38px", objectFit: "contain" }} />
                    </div>

                    <div
                        style={{ cursor: "pointer", padding: "4px 6px", display: "flex", alignItems: "center" }}
                        onClick={() => this.props.navigate && this.props.navigate("/Cart")}
                        title="Cart"
                    >
                        <Badge badgeContent={this.state.badgeCount} color="warning">
                            <img src={ShoppingCart} style={{ width: 24, height: 24 }} alt="Cart" />
                        </Badge>
                    </div>
                </div>

                <div style={{ display: 'flex', position: 'relative', marginTop: 8 }} className='SearchPageField'>
                    <input
                        placeholder={language.searchLabel}
                        style={{ fontFamily: 'Poppins-Regular', border: 'none', padding: '9px 38px 9px 12px', width: '100%', borderRadius: 17, outline: 'none', backgroundColor: '#f5f5f5' }}
                        autoCapitalize={'none'}
                        autoFocus={true}
                        onChange={(event) => this.setState({ searchedProductName: event.target.value })}
                        onSubmit={() => this.searchProduct()}
                        defaultValue={this.props.value}
                        inputMode='search'
                        onKeyDown={(e)=>this.keydown(e)}
                    />
                    <div style={{ position: 'absolute', right: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => this.searchProduct()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20px" height="20px" fill="#666"><path d="M 20.5 6 C 12.515556 6 6 12.515562 6 20.5 C 6 28.484438 12.515556 35 20.5 35 C 23.773158 35 26.788919 33.893018 29.220703 32.050781 L 38.585938 41.414062 A 2.0002 2.0002 0 1 0 41.414062 38.585938 L 32.050781 29.220703 C 33.893017 26.788918 35 23.773156 35 20.5 C 35 12.515562 28.484444 6 20.5 6 z M 20.5 10 C 26.322685 10 31 14.677319 31 20.5 C 31 23.295711 29.914065 25.820601 28.148438 27.697266 A 2.0002 2.0002 0 0 0 27.701172 28.144531 C 25.824103 29.912403 23.29771 31 20.5 31 C 14.677315 31 10 26.322681 10 20.5 C 10 14.677319 14.677315 10 20.5 10 z"  />
                        </svg>
                    </div>
                </div>
            </div>
        );
    }
}

export default function (props) {
    const { toggleDrawer } = useContext(AuthContext);
    const navigate = useNavigate();
    return <SearchHeader {...props} toggleDrawer={toggleDrawer} navigate={navigate} />;
}